import { LocalStorageEnum } from './enums';

export class LocalStorage {

  static saveToStorage(type: LocalStorageEnum, value: any): boolean {
    try {
      if (value) {
        sessionStorage.setItem(type, JSON.stringify(value));
      }
      return true;
    } catch (error) {
      return false;
    }

  }

  static getFromStorage(type: LocalStorageEnum): any {

    const item: string | null = sessionStorage.getItem(type);
    if (item) {
      const result: any = JSON.parse(item);
      return result;
    }

    return undefined;

  }

  static reset(): void {
    sessionStorage.clear();
    localStorage.clear();
  }

}
